<script setup>
// Wpis dnia: krótki tekst przypisany do godziny. Zostaje w dniu — inaczej niż
// notatka, nie ląduje w Notatniku i nie ma tytułu (API przyjmuje tylko treść).
import WhenFields from '@/components/v2/add/when-fields.vue';
import { useI18n } from 'vue-i18n';

defineProps({
    draft: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
</script>

<template>
    <div>
        <textarea
            v-model="draft.content"
            rows="4"
            class="v2-freetext"
            :placeholder="t('entry.report.contentPlaceholder')"
            :aria-invalid="!!errors.content"
        ></textarea>
        <p v-if="errors.content" class="text-[11.5px] text-[#B5643C]">{{ errors.content }}</p>

        <div class="border-t border-[#EFE9DF] pt-4 mt-4">
            <WhenFields :draft="draft" :errors="errors" />
        </div>
    </div>
</template>
